import { createBrowserRouter, type RouteObject } from "react-router-dom";
import RootRedirect from "../components/auth/RootRedirect";
import RouteErrorBoundary from "../features/shared/pages/ErrorBoundary";
import NotFound from "../features/shared/pages/NotFound";
import { dashboardRoutes } from "./routes/dashboardRoutes";
import { legacyRoutes } from "./routes/legacyRoutes";
import { accountsMasterRoutes, salesMasterRoutes } from "./routes/masterRoutes";
import { reportRoutes } from "./routes/reportRoutes";
import {
  accountsTransactionRoutes,
  otherTransactionRoutes,
  salesTransactionRoutes,
} from "./routes/transactionRoutes";
import { payableRoutes, utilityRoutes } from "./routes/utilityAndPayableRoutes";

const routeDefinitions: RouteObject[] = [
  { path: "/", element: <RootRedirect />, errorElement: <RouteErrorBoundary /> },
  ...dashboardRoutes,
  ...salesMasterRoutes,
  ...accountsMasterRoutes,
  ...salesTransactionRoutes,
  ...accountsTransactionRoutes,
  ...otherTransactionRoutes,
  ...reportRoutes,
  ...utilityRoutes,
  ...payableRoutes,
  ...legacyRoutes,
  { path: "*", element: <NotFound />, errorElement: <RouteErrorBoundary /> },
];

export const router = createBrowserRouter(routeDefinitions);
